import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import DialogTitle from "@material-ui/core/DialogTitle";
import withIntl from "../../../utils/withIntl";
import { Grid, Hidden, Switch, TableBody, Typography } from "@material-ui/core";
import DialogContent from "@material-ui/core/DialogContent";
import GetCurrency from "../../../helper/GetCurrency";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import TablePagination from "@material-ui/core/TablePagination";
import withStyles from "@material-ui/core/styles/withStyles";
import EditPriceTextField from "../../EditArticle/EditPriceTextField";
import { updatePostalCodes } from "../PostalCodeApi";
import EditTextField from "../../EditArticle/EditTextField";
import { useDialog } from "../../Dialogs/DialogProvider";
import { rowsPerPage } from "../PostalCodes";

const StyledTableCell = withStyles(() => ({
  head: {
    fontWeight: "bold",
    lineHeight: 1.2,
    width: 50,
    padding: 0,
  },
  body: {
    fontSize: 12,
    padding: 0,
  },
}))(TableCell);
const StyledTableCellNew = withStyles(() => ({
  body: {
    fontSize: 12,
    padding: 0,
    color: "green",
    fontWeight: "bold",
  },
}))(TableCell);

const StyledTableRow = withStyles(() => ({
  root: {
    // "&:nth-of-type(odd)": {
    //   backgroundColor: theme.palette.action.hover,
    // },
  },
}))(TableRow);

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  table: {
    width: "100%",
  },
  form: {
    margin: 0,
    padding: 0,
    // width: "100%",
    // border: "2px solid purple",
  },
  section: {
    // border: "solid 2px orange",
  },
  section2: {
    // border: "solid 2px red",
    width: "100%",
    margin: 0,
    padding: 0,
  },
  tableCellRoot: {
    padding: 1,
    lineHeight: 1.2,
    width: 20,
    fontSize: 12,
    fontWeight: "bold",
  },
  button: { margin: 10 },
}));

function AddPostalCodesDialog(props) {
  const classes = useStyles();
  const [, closeDialog] = useDialog();
  const [toPostalCodeMultiple, setToPostalCodeMultiple] = useState(null);
  const [newAndOldPostalCodes, setNewAndOldPostalCodes] = useState(props.postalCodes);
  const [codeCheck, setCodeCheck] = useState(null);
  const [templatePostalCode, setTemplatePostalCode] = useState({
    postal_code: "",
    amount_with_extra_costs: 0,
    extra_costs: 0,
    min_amount: 0,
    active: true,
    justAdded: true,
  });

  const { postalCodes, addNewPostalCode } = props;

  const [page, setPage] = React.useState(0);

  const setPostalCodes = () => {
    let updatedPostalCodes = newAndOldPostalCodes.filter((postalCode) => postalCode.justAdded);
    updatedPostalCodes.forEach((postalCode) => {
      delete postalCode["justAdded"];
    });
    updatePostalCodes(
      props.taMerchantId,
      updatedPostalCodes.map((postalCode) => ({ ...postalCode, id: postalCode.id != null ? postalCode.id : 0 })),
      updatedPostalCodes
    ).then((data) => {
      addNewPostalCode(data);
      closeDialog();
    });
  };

  const removePostalCode = (newCode) => {
    const index = newAndOldPostalCodes.map((code) => code.postal_code).indexOf(newCode.postal_code);
    const newArray = [...newAndOldPostalCodes];
    newArray.splice(index, 1);
    setNewAndOldPostalCodes(newArray);
  };

  const handleChange = (name, value) => {
    setTemplatePostalCode({ ...templatePostalCode, [name]: value });
  };

  const handleChangeSwitch = () => {
    setTemplatePostalCode({ ...templatePostalCode, active: !templatePostalCode.active });
  };

  const validatePostalCodeExists = (postalCode) => {
    setCodeCheck(null);
    return newAndOldPostalCodes.map((newPostalCode) => newPostalCode.postal_code).includes(postalCode);
  };

  const addPostalCode = () => {
    if (toPostalCodeMultiple) {
      let fromPostalCode = parseInt(templatePostalCode.postal_code);
      let toPostalCode = parseInt(toPostalCodeMultiple);
      if (toPostalCode < fromPostalCode) {
        setCodeCheck("Postal_codes_must_be_in_ascending_order");
      } else {
        let i;
        let copyNewAndOldPostalCodes = [...newAndOldPostalCodes];
        let newMultiplePostalCodes = [];
        for (i = fromPostalCode; i <= toPostalCode; i++) {
          let copyTemplatePostalCode = { ...templatePostalCode, postal_code: i.toString() };
          newMultiplePostalCodes.push(i.toString());
          if (validatePostalCodeExists(i.toString())) {
            let indexExistingCode = copyNewAndOldPostalCodes.map((code) => code.postal_code).indexOf(i.toString());
            Object.keys(copyTemplatePostalCode).forEach((key) => {
              copyNewAndOldPostalCodes[indexExistingCode][key] = copyTemplatePostalCode[key];
            });
          } else {
            copyNewAndOldPostalCodes.push(copyTemplatePostalCode);
          }
        }
        let existingPostalCodes = [];
        newMultiplePostalCodes.forEach((postalCode) => {
          if (validatePostalCodeExists(postalCode)) {
            existingPostalCodes.push(postalCode);
          }
        });
        if (existingPostalCodes.length > 0) {
          if (
            !window.confirm(
              `${props.intl.formatMessage({
                id: "Postalcodes_already_exist_and_will_be_overwritten",
              })}${existingPostalCodes}`
            )
          ) {
            return;
          }
        }
        setNewAndOldPostalCodes(copyNewAndOldPostalCodes);
      }
    } else {
      if (validatePostalCodeExists(templatePostalCode.postal_code)) {
        setCodeCheck("Postal_code_already_exists");
        return;
      } else if (templatePostalCode.postal_code === "") {
        setCodeCheck("Postal_code_must_not_be_empty");
        return;
      }
      setNewAndOldPostalCodes([...newAndOldPostalCodes, { ...templatePostalCode }]);
    }
  };

  return (
    <>
      <DialogTitle id="simple-dialog-title">{props.intl.formatMessage({ id: "add_postal_codes" })}</DialogTitle>
      <DialogContent className={classes.section}>
        <form className={classes.form}>
          <Grid container alignItems={"flex-end"} spacing={1}>
            <Grid container item xs={2} sm={1} justify={"flex-end"} style={{ paddingBottom: 5 }}>
              {props.intl.formatMessage({ id: "from" })}:
            </Grid>
            <Grid container item xs={10} sm={2}>
              <EditTextField
                id="standard-error-helper-text"
                style={{ width: "12ch" }}
                size="small"
                label={props.intl.formatMessage({ id: "postal_code" })}
                variant="standard"
                color="primary"
                onBlur={(value) => {
                  const newValue = value.replace(/[^a-zA-Z0-9]/gi, "");
                  handleChange("postal_code", newValue);
                }}
              />
            </Grid>
            <Grid container item xs={2} sm={1} justify={"flex-end"} style={{ paddingBottom: 5 }}>
              {props.intl.formatMessage({ id: "to" })}:
            </Grid>
            <Grid container item xs={10} sm={2}>
              <EditTextField
                id="standard-error-helper-text"
                style={{ width: "12ch" }}
                size="small"
                label={props.intl.formatMessage({ id: "postal_code_optional" })}
                variant="standard"
                color="primary"
                onBlur={(value) => {
                  const newValue = value.replace(/[^a-zA-Z0-9]/gi, "");
                  setToPostalCodeMultiple(newValue);
                  setToPostalCodeMultiple(newValue);
                }}
              />
            </Grid>
            <Grid container item xs={2} sm={6} />

            <Grid container item xs={10} sm={3}>
              <EditPriceTextField
                style={{ maxWidth: "16ch" }}
                variant={"standard"}
                price={templatePostalCode.amount_with_extra_costs}
                label={props.intl.formatMessage({ id: "amount_with_extra" })}
                onBlur={(value) => {
                  handleChange("amount_with_extra_costs", value);
                }}
              />
            </Grid>
            <Hidden smUp>
              <Grid container item xs={2} />
            </Hidden>
            <Grid container item xs={10} sm={3}>
              <EditPriceTextField
                style={{ maxWidth: "16ch" }}
                variant={"standard"}
                price={templatePostalCode.extra_costs}
                label={props.intl.formatMessage({ id: "extra_amount" })}
                onBlur={(value) => {
                  handleChange("extra_costs", value);
                }}
              />
            </Grid>
            <Hidden smUp>
              <Grid container item xs={2} />
            </Hidden>
            <Grid container item xs={10} sm={3}>
              <EditPriceTextField
                style={{ maxWidth: "16ch" }}
                variant={"standard"}
                price={templatePostalCode.min_amount}
                label={props.intl.formatMessage({ id: "minimum_amount" })}
                onBlur={(value) => {
                  handleChange("min_amount", value);
                }}
              />
            </Grid>
            <Hidden smUp>
              <Grid container item xs={2} />
            </Hidden>
            <Grid container item xs={10} sm={3} justify={"flex-start"}>
              <Switch
                onChange={handleChangeSwitch}
                checked={!!templatePostalCode.active}
                size="small"
                color="primary"
              />
            </Grid>
          </Grid>
        </form>
        {codeCheck && (
          <Typography variant={"subtitle1"} style={{ color: "red" }}>
            {props.intl.formatMessage({ id: codeCheck })}
          </Typography>
        )}
        <DialogActions className={classes.section}>
          <Button onClick={addPostalCode} variant={"contained"} color="primary">
            {props.intl.formatMessage({ id: "add" })}
          </Button>
        </DialogActions>
        <div>
          <DialogTitle id="simple-dialog-title">{props.intl.formatMessage({ id: "preview" })}</DialogTitle>
          <TableContainer component="div">
            <Table className={classes.table}>
              <TableHead>
                <TableRow>
                  <StyledTableCell>{props.intl.formatMessage({ id: "postal_codes" })}</StyledTableCell>
                  <StyledTableCell>{props.intl.formatMessage({ id: "amount_with_extra" })}</StyledTableCell>
                  <StyledTableCell>{props.intl.formatMessage({ id: "extra_amount" })}</StyledTableCell>
                  <StyledTableCell>{props.intl.formatMessage({ id: "minimum_amount" })}</StyledTableCell>
                  <StyledTableCell>{props.intl.formatMessage({ id: "active" })}</StyledTableCell>
                  <StyledTableCell />
                </TableRow>
              </TableHead>
              <TableBody>
                {newAndOldPostalCodes
                  .sort((x, y) => {
                    return parseInt(x.postal_code) - parseInt(y.postal_code);
                  })
                  .sort((x, y) => {
                    return x.justAdded === y.justAdded ? 0 : x.justAdded ? -1 : 1;
                  })
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((code, i) => {
                    if (code.justAdded) {
                      return (
                        <StyledTableRow key={code.postal_code}>
                          <StyledTableCellNew>{code.postal_code}</StyledTableCellNew>
                          <StyledTableCellNew>
                            {GetCurrency()}
                            {(code.amount_with_extra_costs / 100.0).toFixed(2)}
                          </StyledTableCellNew>
                          <StyledTableCellNew>
                            {GetCurrency()}
                            {(code.extra_costs / 100.0).toFixed(2)}
                          </StyledTableCellNew>
                          <StyledTableCellNew>
                            {GetCurrency()} {(code.min_amount / 100.0).toFixed(2)}
                          </StyledTableCellNew>
                          <StyledTableCellNew>
                            <Switch checked={!!code.active} disabled="true" size="small" color="primary" />
                          </StyledTableCellNew>
                          <StyledTableCellNew>
                            <RemoveCircleIcon className={classes.textField} onClick={() => removePostalCode(code)} />
                          </StyledTableCellNew>
                        </StyledTableRow>
                      );
                    } else {
                      return (
                        <StyledTableRow key={code.postal_code}>
                          <StyledTableCell> {code.postal_code}</StyledTableCell>
                          <StyledTableCell>
                            {GetCurrency()}
                            {(code.amount_with_extra_costs / 100.0).toFixed(2)}
                          </StyledTableCell>
                          <StyledTableCell>
                            {GetCurrency()}
                            {(code.extra_costs / 100.0).toFixed(2)}
                          </StyledTableCell>
                          <StyledTableCell>
                            {GetCurrency()} {(code.min_amount / 100.0).toFixed(2)}
                          </StyledTableCell>
                          <StyledTableCell>
                            <Switch checked={!!code.active} disabled="true" size="small" color="primary" />
                          </StyledTableCell>
                        </StyledTableRow>
                      );
                    }
                  })}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            component="div"
            count={newAndOldPostalCodes.filter((row) => row.postal_code).length}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={(event, newPage) => {
              setPage(newPage);
            }}
            labelRowsPerPage=""
            rowsPerPageOptions={[rowsPerPage]}
          />
        </div>
      </DialogContent>
      <DialogActions className={classes.section}>
        <Button
          onClick={() => {
            closeDialog();
          }}
          color="primary"
        >
          {props.intl.formatMessage({ id: "cancel" })}
        </Button>
        <Button onClick={setPostalCodes} variant={"contained"} color="primary">
          {props.intl.formatMessage({ id: "save" })}
        </Button>
      </DialogActions>
    </>
  );
}

export default withIntl(AddPostalCodesDialog);
